(function ($) {
    $.widget('femcare.genericModal', {
        options: {},
        contentSourceSelector: null,

        _create: function () {
            this.$body = this.element.find('.modal-body');
        },

        open: function (newContentSourceSelector) {

            // Return existing content to source before appending new content
            // Mostly needed because of duplicate id concerns
            if (this.contentSourceSelector) {
                $(this.contentSourceSelector).append(this.$body.children());
            }

            // Append new content
            this.contentSourceSelector = newContentSourceSelector;
            this.$body.append($(newContentSourceSelector).children());

            // Reset form
            var $form = this.$body.find('form');
            if ($form.length) {
                $form.resetForm();
            }

            this.element.modal('show');
        }
    })

}(jQuery));